module.exports = __webpack_public_path__ + "static/media/knights_helmet.f0ee0ac5.png";